import * as React from "react";
import { cn } from "../lib/cn";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  error?: string;
}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, error, ...props }, ref) => (
  <div className="w-full">
    <input
      ref={ref}
      className={cn(
        "flex h-10 w-full rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm text-gray-900 shadow-[0_1px_2px_0_rgb(0_0_0/0.05)] placeholder:text-gray-400 transition-all duration-150",
        "focus-visible:outline-none focus-visible:border-blue-500 focus-visible:ring-3 focus-visible:ring-blue-500/15",
        "disabled:cursor-not-allowed disabled:opacity-50 disabled:bg-gray-50",
        "hover:border-gray-300",
        error && "border-red-400 focus-visible:border-red-500 focus-visible:ring-red-500/15",
        className,
      )}
      {...props}
    />
    {error && <p className="mt-1.5 text-xs text-red-600 flex items-center gap-1">{error}</p>}
  </div>
));
Input.displayName = "Input";

export const Label = React.forwardRef<HTMLLabelElement, React.LabelHTMLAttributes<HTMLLabelElement>>(
  ({ className, ...props }, ref) => (
    <label ref={ref} className={cn("text-sm font-medium text-gray-700 leading-none", className)} {...props} />
  ),
);
Label.displayName = "Label";
